import { render, staticRenderFns } from "./UploadPhotoModal.vue?vue&type=template&id=3a8350e2&scoped=true"
import script from "./UploadPhotoModal.vue?vue&type=script&lang=js"
export * from "./UploadPhotoModal.vue?vue&type=script&lang=js"
import style0 from "./UploadPhotoModal.vue?vue&type=style&index=0&id=3a8350e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8350e2",
  null
  
)

export default component.exports